/*
 * @FilePath: index.js
 * @Author: chenwei
 * @Date: 2022-05-19 10:39:25
 * @LastEditors: chenwei
 * @LastEditTime: 2022-09-01 14:14:30
 * Copyright: 2022 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion: 
 */
import {get,post} from '@/utils/request'
import {proxyHeader} from "@/utils/config"

//根据用户信息
export const getUserInfo = p => get(proxyHeader+'grs-web/user/getUserInfo', p);

//获取最新产品列表
export const getNwestList = p => get(proxyHeader+'service/product-service/product-data/list', p);

//获取热门产品数据
export const getHotList = p => get(proxyHeader+'service/product-service/product-data/listHot', p);

//首页资源统计产品数据
export const allProductSum = p => get(proxyHeader+'service/product-service/product-data/allProductSum', p);

//首页资源统计 卫星数据
export const allSatelliteSum = p => get(proxyHeader+'service/satellite-service/product-count/allProductSum', p);

//首页 服务统计 注册人数和网站访问量
export const serviceStatMenAndGlanced = p => get(proxyHeader+'service/product-service/product-data/serviceStatMenAndGlanced', p);

//首页服务统计 下载量 下载次数
export const getIndexSum = p => get(proxyHeader+'service/order-service/order/indexSum', p);

//遥感云计算申请
export const jupterApply = p => post(proxyHeader+'csf/dataprocess/jupyter-server/apply', p);

//每日一图
export const dayImage = p => get(proxyHeader+'service/product-service/pdDailyProduct/latest', p);

//算法统计
export const getSumAlgorithm = p => get(proxyHeader+'service/product-service/product-data-file/sumAlgorithm', p);

//算法统计
export const sumMutipleStTypes = p => get(proxyHeader+'service/satellite-service/satellite/sumMutipleStTypes', p);

//平台访问量统计
export const browseRecord = p => get(proxyHeader+'service/common-service/accress-record/browse', p);

//视频教程
export const operateData = p => get(proxyHeader+'service/common-service/sys-operate/queryList', p);